import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || '';



const getAllLearns = async () => {

    const token = localStorage.getItem('token');

    const response = await axios.get(`https://www.kipmate.com/sortyourkip/api/media/getlearns`, {
        headers: {
            Authorization: `${token}`
        },
    });

    return response.data
}





const learnService = { getAllLearns }

export default learnService;
